import React, { useEffect, useState } from "react";
import axiosInstance from "../../api/axiosInstance";  // ✅ FIXED IMPORT PATH
import "./news.css";

const News = () => {
  const [posts, setPosts] = useState([]);

  useEffect(() => {
    fetchPosts();
  }, []);

  const fetchPosts = async () => {
    try {
      const res = await axiosInstance.get("/posts");  
      setPosts(res.data);
    } catch (err) {
      console.error("Error fetching posts:", err);
    }
  };

  return (
    <section id="news">
      <h2 className="newsTitle">Recent Rugby News</h2>
      <div className="newsContent">
        {posts.length === 0 ? (
          <p>No posts available</p>
        ) : (
          posts.map((post) => (
            <div key={post.id} className="newsItem">
              <h3>{post.title}</h3>
              <p>{post.content}</p>
              {post.media_url && (
                post.media_url.endsWith(".mp4") ? (
                  <video controls src={`http://localhost:5000${post.media_url}`} className="newsMedia" />
                ) : (
                  <img src={`http://localhost:5000${post.media_url}`} alt="Post media" className="newsMedia" />
                )
              )}
            </div>
          ))
        )}
      </div>
    </section>
  );
};

export default News;
